import { render, staticRenderFns } from "./plateformCompany.vue?vue&type=template&id=cc22af2e"
import script from "./plateformCompany.vue?vue&type=script&lang=js"
export * from "./plateformCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports